import {
  TyrianApp
} from '../target/scala-3.3.3/rocketapi-frontend-fastopt/main.js';

TyrianApp.launch("myapp");
